export const exportFormats = {
  csv: 'csv',
  rtf: 'rtf'
};

// CSV is the format the exporter has always produced, so it stays the default.
export const defaultExportFormat = exportFormats.csv;

export const exportFormatOptions = [
  {
    value: exportFormats.csv,
    label: 'CSV',
    description: 'Spreadsheet, for uploading to the LMS'
  },
  {
    value: exportFormats.rtf,
    label: 'RTF',
    description: 'Formatted document, for uploading to ExamSoft'
  }
];

export const isExportFormat = format => Object.values(exportFormats).includes(format);

export const zipFileFormat = 'application/zip';
